import type React from "react";
import type {SegmentationSource, SegmentationType} from "~/pages/supplier-360/types/Supplier360Types";
import {Tag} from "~/components/tag/Tag";
import {
    SEGMENT_COLOR,
    SEGMENT_DESCRIPTION,
    SEGMENT_LABEL,
    SEGMENT_TAG_COLOR,
} from "./kraljicSegments";

type SegmentTagProps = {
    segment: SegmentationType;
    /** `manual` adds the design's " · manual" suffix, so an overridden segment reads as one. */
    source?: SegmentationSource;
    size?: 'small' | 'medium';
};

/**
 * The design's `SegBadge` — the segment as a tag in its quadrant's colour, on that colour's tint,
 * titled with what the quadrant means.
 */
export const SegmentTag: React.FC<SegmentTagProps> = ({segment, source, size = 'small'}) => (
    <Tag
        size={size}
        title={SEGMENT_DESCRIPTION[segment]}
        label={source === 'manual' ? `${SEGMENT_LABEL[segment]} · manual` : SEGMENT_LABEL[segment]}
        variant="outlined"
        color={SEGMENT_TAG_COLOR[segment]}
        sx={{fontSize: 11.5, fontWeight: 500, '&&': {backgroundColor: SEGMENT_COLOR[segment].tint}}}
    />
);
